/* eslint-disable sonarjs/no-duplicate-string */
'use client';
import {
  Label,
  ProductCardImage,
  Typography,
} from '@curology/ui-components-web';
import HeartIcon from '@curology/ui-components-web/react/Icon/icons/HeartIcon';
import clsx from 'clsx';
import Image from 'next/image';
import { useState } from 'react';
import Slider from 'react-slick';

import './css/carousel.css';
import { DATA_KEYS } from '@/consts/dataKeys';

import { useDataProvider } from '../../components/DataProvider/useDataProvider';

const images = {
  male: [
    {
      url: '//images.ctfassets.net/8pzh4g8cs30t/4GtG66iYFVZb3XMCIBRs8e/7dbfb489391f1912a2f98e5cc37ff8bb/70051cafeab7db0baf1ab0ebf190340c35c19684.jpg',
      details: { size: 6107113, image: { width: 4096, height: 2732 } },
      fileName: '70051cafeab7db0baf1ab0ebf190340c35c19684.jpg',
      contentType: 'image/jpeg',
    },
    {
      url: '//images.ctfassets.net/8pzh4g8cs30t/63Ai3UpNU0cuYMvjSABef6/e2061622b202afa0c80c4dbe854d98d6/8207d0e340b3bdeaf10d64a8534398fedc343c34.jpg',
      details: { size: 86285, image: { width: 960, height: 720 } },
      fileName: '8207d0e340b3bdeaf10d64a8534398fedc343c34.jpg',
      contentType: 'image/jpeg',
    },
    {
      url: '//images.ctfassets.net/8pzh4g8cs30t/4a8eUNQgRbxCFi3ILqG0ut/dee60e5c75707998b4f2c33ad4c30dde/Group_1197135674.png',
      details: { size: 246339, image: { width: 672, height: 448 } },
      fileName: 'Group 1197135674.png',
      contentType: 'image/png',
    },
    {
      url: '//images.ctfassets.net/8pzh4g8cs30t/408K9K1S6A59hZOx2ZktjV/345de70c3c525c3a13c1bb88893b471d/6e95def685bb8349e03b7d87d774fe1444b0a58c.jpg',
      details: { size: 67565, image: { width: 960, height: 720 } },
      fileName: '6e95def685bb8349e03b7d87d774fe1444b0a58c.jpg',
      contentType: 'image/jpeg',
    },
    {
      url: '//images.ctfassets.net/8pzh4g8cs30t/49zIzEUxJCIpDimb1tgBeH/da182501bab6e108f47de54aa229f98e/derm_image_2x.png',
      details: { size: 243329, image: { width: 670, height: 446 } },
      fileName: 'derm_image@2x.png',
      contentType: 'image/png',
    },
  ],
  female: [
    {
      url: '//images.ctfassets.net/8pzh4g8cs30t/4xAmwEDHHlPYqTXaleGMEI/16f7195daa22af965b72ee135aeb5de2/4da3a864ed25ebad2a80002f1d1c90303040fd18.jpg',
      details: { size: 64488, image: { width: 960, height: 720 } },
      fileName: '4da3a864ed25ebad2a80002f1d1c90303040fd18.jpg',
      contentType: 'image/jpeg',
    },
    {
      url: '//images.ctfassets.net/8pzh4g8cs30t/7l1gesfY5ZoR2k8QwzomrR/b2f18325c12badcdc9fb50ce366cc8d4/Aspect-Ratio-Hack-Images.png',
      details: { size: 500471, image: { width: 672, height: 448 } },
      fileName: 'Aspect-Ratio-Hack-Images.png',
      contentType: 'image/png',
    },
    {
      url: '//images.ctfassets.net/8pzh4g8cs30t/4a8eUNQgRbxCFi3ILqG0ut/dee60e5c75707998b4f2c33ad4c30dde/Group_1197135674.png',
      details: { size: 246339, image: { width: 672, height: 448 } },
      fileName: 'Group 1197135674.png',
      contentType: 'image/png',
    },
    {
      url: '//images.ctfassets.net/8pzh4g8cs30t/6Q9hx1KUpqLi8ZSH7s8t5K/c535a9435a9489abb31e65f0445d48bf/Group_1197135675.png',
      details: { size: 480652, image: { width: 672, height: 448 } },
      fileName: 'Group 1197135675.png',
      contentType: 'image/png',
    },
    {
      url: '//images.ctfassets.net/8pzh4g8cs30t/4GtG66iYFVZb3XMCIBRs8e/7dbfb489391f1912a2f98e5cc37ff8bb/70051cafeab7db0baf1ab0ebf190340c35c19684.jpg',
      details: { size: 6107113, image: { width: 4096, height: 2732 } },
      fileName: '70051cafeab7db0baf1ab0ebf190340c35c19684.jpg',
      contentType: 'image/jpeg',
    },
  ],
};

const ProductHeroCarousel = () => {
  const patient = useDataProvider(DATA_KEYS.patient);
  const personalizedImages = images[patient?.gender || 'male'];

  return (
    <div className="product-card-image-carousel-container">
      <Slider
        accessibility={true}
        arrows={false}
        dots={true}
        draggable={true}
        infinite={true}
      >
        {personalizedImages.map((image) => {
          return (
            <ProductCardImage
              alt={'Example product image'}
              aspectRatio="3:2"
              className="cur-cursor-default"
              key={image.url}
              onClick={(event) => event.stopPropagation()}
              src={image.url}
            />
          );
        })}
      </Slider>
    </div>
  );
};

const ProductIngredients = () => {
  const ingredients = [
    {
      title: 'Sulfacetamide',
      description:
        'An antibiotic that fights acne-contributing bacteria on the skin',
      thumbnail:
        'https://images.ctfassets.net/mdcr7mahi0vp/3HSGJGQ3SIrIydNwZ408qi/9969bc787e42e1c74f4a725dd620b595/niacinamide_ingredient_sample.png',
    },
    {
      title: 'Zinc pyrithione',
      description:
        'An antimicrobial that helps keep bacteria and fungi in check while soothing inflammation',
      thumbnail:
        'https://images.ctfassets.net/mdcr7mahi0vp/3grQHUj4mcINVswiX9B37c/b6cff566ab00f7a7b3e470b1d48b9aca/zinc_pyrithione_ingredient_sample.png',
    },
    {
      title: 'Salicylic acid',
      description:
        'A chemical exfoliant that clears away dead skin cells, dirt, and excess oil',
      thumbnail:
        'https://images.ctfassets.net/mdcr7mahi0vp/3R53SG6Gq60lOcc69Q2UGh/4dfe4f2045220d69b32e66477a98a109/tranexamic_acid_ingredient_sample.png',
    },
  ];

  const [selectedIngredient, setSelectedIngredient] = useState(ingredients[0]);

  return (
    <div>
      <ul className="cur-flex cur-mb-0 cur-overflow-x-auto">
        {ingredients.map((ingredient, index) => (
          <li className="cur-shrink-0" key={ingredient.title}>
            <div
              className={clsx(
                'cur-p-4 cur-border-b-2',
                ingredient.title === selectedIngredient?.title
                  ? 'cur-border-border-secondary'
                  : 'cur-border-transparent',
              )}
              onClick={() => setSelectedIngredient(ingredient)}
            >
              <Image
                alt={ingredient.title || 'example ingredient'}
                height="40"
                src={ingredient.thumbnail}
                width="40"
              />
            </div>
          </li>
        ))}
      </ul>
      {selectedIngredient && (
        <div className="cur-pt-3">
          <Typography className="cur-text-[14px]" size="body" weight="bold">
            {selectedIngredient.title}
          </Typography>
          <Typography size="body" className="cur-my-2 cur-text-[14px]">
            {selectedIngredient.description}
          </Typography>
        </div>
      )}
    </div>
  );
};

const ProductCard = () => {
  return (
    <div className="cur-flex cur-flex-col cur-bg-white">
      <div className="cur-relative cur-p-1">
        <div className="cur-relative">
          <div className="cur-absolute cur-z-20 cur-top-0 cur-left-0">
            <span className="cur-inline-flex cur-items-center cur-bg-surface-brand-accent cur-px-2 cur-py-1 cur-text-meta cur-font-bold text-gray-600">
              Rx for body acne
            </span>
          </div>
          <ProductHeroCarousel />
        </div>
      </div>
      <div className="cur-py-4 cur-px-4">
        <div className="cur-cursor-pointer">
          <div className="cur-flex cur-justify-between cur-items-center">
            <Typography size="h3">
              Body Cleanse<sup>Rx</sup>
            </Typography>
            <Label labelType="subtle" className="cur-flex cur-items-center">
              <HeartIcon className="cur-w-4 cur-h-4" />
              <span className="cur-ml-1">Designed for you</span>
            </Label>
          </div>
          <Typography className="cur-mt-2" size="subhead">
            Custom Acne Treatment Body Wash
          </Typography>
          <div className="cur-flex cur-items-center cur-mt-1">
            <Typography size="subhead" className="cur-font-bold">
              $14.00{' '}
              <span className="cur-line-through cur-font-normal cur-text-[#B9B9C5]">
                $29.95
              </span>{' '}
              <span className="cur-font-normal">(30-day supply)</span>
            </Typography>
          </div>
          <Typography className="cur-mt-1" size="body">
            Powered by a personalized blend of clinically proven active
            ingredients, Body Cleanse<sup>Rx</sup> works deep into pores to help
            clear and prevent body acne so you can feel confident from
            head-to-toe.
          </Typography>
        </div>
        <ProductIngredients />
      </div>
    </div>
  );
};

export { ProductCard };
